import {ChangeEvent, FC, useCallback, useEffect, useState} from 'react';
import {MAX_LENGTH_FULL_NAME} from '~/common/constants/users';
import {Button} from '~library/atoms/Button';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';
import {PlusIcon} from '~library/svg/PlusIcon';
import {TrashIcon} from '~library/svg/v2/TrashIcon';

import {linkPrimary} from '~libSass/v2/_exports.sass';

interface CohostProps {
  cohost: {name: string; email: string};
  onChange: (field: 'name' | 'email', value: string) => void;
  errors: {name?: string; email?: string};
  removeCohost: () => void;
  shouldExpandCohost?: boolean;
}

export const Cohost: FC<CohostProps> = ({
  cohost,
  onChange,
  errors,
  removeCohost,
  shouldExpandCohost,
}) => {
  const {name, email} = cohost;

  const [expandFields, setExpandFields] = useState(shouldExpandCohost);

  const handleRemoveCohost = useCallback(() => {
    setExpandFields(false);
    removeCohost();
  }, [removeCohost]);

  useEffect(() => {
    setExpandFields(shouldExpandCohost);
  }, [shouldExpandCohost]);

  return (
    <>
      <Typography variant="paragraph1" semibold>
        Add a co-host
      </Typography>
      <Typography className="event-details__cohost-copy" variant="paragraph2" color="asphalt">
        The more the merrier! Your co-host will get an email prompting them to join and manage the
        event.
      </Typography>
      {!expandFields && (
        <Button
          variant="link"
          data-qa-id="add-cohost"
          onClick={() => setExpandFields(true)}
          className="event-details__cohost-button"
          type="button"
        >
          <PlusIcon ratio={0.5} color={linkPrimary} />
          Add a co-host
        </Button>
      )}
      {expandFields && (
        <div className="create-flow__form-section  event-details__cohost">
          <Typography
            className="event-details__cohost-label"
            as="label"
            variant="label2"
            size="small"
          >
            Co-host{' '}
            <Button variant="transparent" data-qa-id="remove-cohost" onClick={handleRemoveCohost}>
              <TrashIcon ratio={0.5} color={linkPrimary} />
            </Button>
          </Typography>
          <Input
            className="event-details__cohost-name"
            data-qa-id="event-cohostoverlay-name"
            error={errors?.name}
            value={name}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onChange('name', e.target.value)}
            placeholder="First and last name"
            autoFocus
            maxLength={MAX_LENGTH_FULL_NAME}
          />
          <Input
            className="event-details__cohost-email"
            data-qa-id="event-cohostoverlay-email"
            error={errors?.email}
            value={email}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onChange('email', e.target.value)}
            placeholder="Email address"
          />
        </div>
      )}
    </>
  );
};
